import React from "react"
import type { TouchableOpacityProps } from "react-native"
import { ButtonText, Button as GluestackButton } from "./gluestack/button"

type ButtonVariant = "primary" | "secondary" | "danger" | "outline" | "ghost"

export interface ButtonProps extends TouchableOpacityProps {
  children: React.ReactNode
  variant?: ButtonVariant
  isLoading?: boolean
  disabled?: boolean
}

export const Button = ({
  children,
  variant = "primary",
  isLoading = false,
  disabled = false,
  className = "",
  ...props
}: ButtonProps) => {
  // Map our variants to gluestack variants/actions
  const getGluestackConfig = () => {
    switch (variant) {
      case "primary":
        return { action: "primary", variant: "solid" }
      case "secondary":
        return { action: "secondary", variant: "solid" }
      case "danger":
        return { action: "negative", variant: "solid" }
      case "outline":
        return { action: "primary", variant: "outline" }
      case "ghost":
        return { action: "primary", variant: "ghost" }
      default:
        return { action: "primary", variant: "solid" }
    }
  }

  const { action, variant: gsVariant } = getGluestackConfig()

  return (
    <GluestackButton
      action={action}
      variant={gsVariant}
      isDisabled={disabled}
      isLoading={isLoading}
      className={className}
      {...props}
    >
      <ButtonText>{children}</ButtonText>
    </GluestackButton>
  )
}
